module.exports = __webpack_public_path__ + "static/media/asset_base_logo_with_text.9bc753ea.svg";